export default "__VITE_ASSET__mQgy9Yys__"